<template>
    <Head title="Email Verification" />

    <jet-authentication-card>
        <div class="flex flex-col text-center w-full mb-4">
            <LogoAppSquare class="h-24 w-24 m-auto" />
        </div>

        <div class="mb-4 text-sm text-gray-600">
            Congratulations, your email has been <span class="text-green-600">verified</span>. You can log in now
            with your username and password that you have registered.
        </div>

        <form @submit.prevent="logout">
            <div class="mt-4 flex items-center justify-end">
                <a
                    href="#"
                    :class="['block w-full px-3 py-1 text-left text-sm leading-6 text-gray-900']"
                    @click.prevent="logout"
                >
                    Login Aplikasi
                </a>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import LogoAppSquare from "@/Logo/LogoAppSquare";
import { Head, Link } from "@inertiajs/inertia-vue3";
import axios from "axios";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        LogoAppSquare,
        Link,
    },

    data() {
        return {};
    },

    methods: {
        async logout() {
            try {
                await axios.post('/logout');
                window.location.href = '/';
            } catch (error) {
                console.error('Logout failed:', error);
            }
        }
    }
});
</script>
